import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  OnlineOfflineUserStatus,
  Thread,
  User,
} from '@freelancer/datastore/collections';
import { Feature } from '@freelancer/feature-flags';
import { IconSize } from '@freelancer/ui/icon';
import { LinkIconPosition } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay } from '@freelancer/ui/picture';
import {
  FontWeight,
  TextAlign,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-messages-list',
  template: `
    <fl-bit>
      <fl-bit class="Heading">
        <fl-text
          i18n="Recent Messages heading"
          [flMarginRight]="Margin.MID"
          [size]="TextSize.XXSMALL"
          [textTransform]="TextTransform.UPPERCASE"
          [weight]="FontWeight.BOLD"
        >
          Recent Messages
        </fl-text>
        <fl-link
          flTrackingLabel="Messages-ViewAll"
          i18n="Recent Messages view all"
          [iconName]="'ui-arrow-right'"
          [iconPosition]="LinkIconPosition.RIGHT"
          [iconSize]="IconSize.XSMALL"
          [link]="'/messages'"
          [size]="TextSize.XXSMALL"
        >
          View All
        </fl-link>
      </fl-bit>

      <fl-bit
        class="List"
        *ngIf="
          threads && threads.length > 0 && users && users.length > 0;
          else noMessages
        "
      >
        <app-message-item
          *ngFor="let thread of threads; trackBy: trackById"
          [thread]="thread"
          [users]="users"
          [onlineOfflineStatuses$]="onlineOfflineStatuses$"
        ></app-message-item>
      </fl-bit>
    </fl-bit>

    <ng-template #noMessages>
      <fl-bit class="Empty">
        <fl-picture
          class="EmptyImg"
          alt="Empty Messages Image"
          i18n-alt="Empty Messages Image"
          [alignCenter]="true"
          [display]="PictureDisplay.BLOCK"
          [flMarginBottom]="Margin.SMALL"
          [src]="'navigation/messages/empty-inbox.svg'"
        >
        </fl-picture>
        <fl-text
          i18n="Messages empty messages"
          [size]="TextSize.XXSMALL"
          [textAlign]="TextAlign.CENTER"
        >
          No messages yet? Connect with people
        </fl-text>
        <fl-text
          i18n="Messages create message"
          [size]="TextSize.XXSMALL"
          [textAlign]="TextAlign.CENTER"
        >
          by
          <fl-link
            flTrackingLabel="Messages-PostProject"
            [link]="'/post-project'"
            [size]="TextSize.XXSMALL"
          >
            creating
          </fl-link>
          <ng-container *flFeature="Feature.SEARCH_POOLS">
            or
            <fl-link
              flTrackingLabel="Messages-BrowseProject"
              [link]="'/search/projects/'"
              [size]="TextSize.XXSMALL"
            >
              bidding
            </fl-link>
            on
          </ng-container>
          a project
        </fl-text>
      </fl-bit>
    </ng-template>
  `,
  styleUrls: ['./messages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesListComponent {
  TextSize = TextSize;
  FontWeight = FontWeight;
  IconSize = IconSize;
  LinkIconPosition = LinkIconPosition;
  Margin = Margin;
  PictureDisplay = PictureDisplay;
  TextAlign = TextAlign;
  TextTransform = TextTransform;
  Feature = Feature;

  @Input()
  onlineOfflineStatuses$: Rx.Observable<ReadonlyArray<OnlineOfflineUserStatus>>;
  @Input() threads: ReadonlyArray<Thread>;
  @Input() users: ReadonlyArray<User>;

  trackById(index: number, thread: Thread) {
    return thread.id;
  }
}
